module.exports = __webpack_public_path__ + "static/media/KMH_5093.98b14ff4.jpg";